import { useState } from "react";
import { FaTimes, FaTag } from "react-icons/fa";
import Button from "../Button/Button";

type CouponInputProps = {
  appliedCoupon?: string;
  onApply: (code: string) => Promise<void>;
  onRemove?: () => void;
  error?: string;
};

const CouponInput = ({ appliedCoupon, onApply, onRemove, error }: CouponInputProps) => {
  const [coupon, setCoupon] = useState("");
  const [isApplying, setIsApplying] = useState(false);
  const [localError, setLocalError] = useState("");

  const handleApply = async () => {
    if (coupon.trim() === "") {
      setLocalError("Informe um código de cupom.");
      setTimeout(() => setLocalError(""), 3000);
      return;
    }
    if (isApplying) {
      return;
    }
    setIsApplying(true);
    await onApply(coupon.trim());
    setCoupon("");
    setIsApplying(false);
  };

  const handleRemove = () => {
    if (onRemove) {
      onRemove();
    }
  };

  return (
    <div className="flex flex-col gap-2 bg-white border rounded shadow p-4">
      <h4 className="text-md font-semibold mb-2">{"Cupom de desconto"}</h4>

      {appliedCoupon ? (
        <div className="flex items-center justify-between gap-2 bg-primary-50 p-2 rounded">
          <span className="font-medium">{appliedCoupon}</span>
          <button
            onClick={handleRemove}
            className="text-primary-600 hover:text-primary-700"
            title={"Remover cupom"}
          >
            <FaTimes />
          </button>
        </div>
      ) : (
        <div>
          <div className="flex gap-2">
            <div className="flex-1 min-w-0">
              <input
                type="text"
                placeholder={"Cupom"}
                value={coupon}
                onChange={(e) => setCoupon(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleApply()}
                disabled={isApplying}
                className="border rounded px-3 py-2 text-sm w-full focus:outline-none focus:ring-1 focus:ring-primary-600 disabled:opacity-50"
              />
            </div>
            <Button
              onClick={handleApply}
              isLoading={isApplying}
              icon={<FaTag className="text-xs shrink-0" />}
              className="px-3 py-2 text-sm flex items-center justify-center gap-1 w-[120px] shrink-0"
            >
              {"Aplicar"}
            </Button>
          </div>
          {(localError || error) && <p className="text-xs text-red-500 mt-1">{localError || error}</p>}
        </div>
      )}
    </div>
  );
};

export default CouponInput;
